import React, { useState } from "react";
import "./menu.css"; // 🔥 Importando o CSS

const Menu: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
    };

    const menuItems = [
        { name: "Home", link: "#home" },
        { name: "Planos", link: "#planos" },
        { name: "Quem somos", link: "#quem-somos" },
    ];

    const navLinkStyle: React.CSSProperties = {
        color: "#d1d1d1",
        textDecoration: "none",
        fontSize: "18px",
        fontWeight: "bold",
        transition: "color 0.3s ease-in-out",
    };

    const navLinkHoverStyle: React.CSSProperties = {
        color: "white",
    };

    return (
        <nav className="menu-container">
            <button
                onClick={toggleMenu}
                className="menu-toggle"
            >
                ☰
            </button>
            <ul className={`menu ${isOpen ? "menu-open" : "menu-closed"}`}>
                {menuItems.map((item, index) => (
                    <li key={index}>
                        <a href={item.link}>{item.name}</a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default Menu;
